import styled, { keyframes } from 'styled-components';
import { red400, neutralWhite } from '../themes/colors';
import { Icon } from '../icon';

export const DropdownRoot = styled.div`
    position: relative;
    display: inline-flex;
    align-self: flex-start;
`;

export const DropdownTrigger = styled.button<{ $isOpen: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 0;
    height: 40px;
    padding: 4px 12px 4px 4px;
    border-radius: 2px;
    border: 1px solid ${p => p.$isOpen ? p.theme.aiChat.pill.expandedBorder : 'transparent'};
    background: ${p => p.$isOpen ? p.theme.aiChat.pill.expandedBackground : p.theme.aiChat.pill.background};
    box-shadow: ${p => p.$isOpen ? p.theme.aiChat.pill.expandedHalo : 'none'};
    cursor: pointer;
    font-family: ${p => p.theme.font};
    font-size: 13px;
    font-weight: 500;
    color: ${p => p.$isOpen ? p.theme.aiChat.pill.leadingIcon : p.theme.aiChat.pill.color};
    transition: background 0.2s, border-color 0.2s, box-shadow 0.2s, color 0.2s;
    outline: none;

    &:hover {
        background: ${p => p.theme.aiChat.pill.expandedBackground};
        border-color: ${p => p.theme.aiChat.pill.expandedBorder};
        color: ${p => p.theme.aiChat.pill.leadingIcon};
    }

    &:focus-visible {
        box-shadow: ${p => p.theme.aiChat.input.focusShadow};
    }
`;

export const TriggerSparklesIcon = styled(Icon)`
    font-size: 14px;
    color: inherit;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const DropdownOverlay = styled.div<{ $width: string | number; $isOpen: boolean }>`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 1000;
    width: ${p => typeof p.$width === 'number' ? `${p.$width}px` : p.$width};
    border-radius: 4px;
    overflow: hidden;
    opacity: ${p => p.$isOpen ? 1 : 0};
    transform: ${p => p.$isOpen ? 'translateY(0)' : 'translateY(-6px)'};
    pointer-events: ${p => p.$isOpen ? 'auto' : 'none'};
    visibility: ${p => p.$isOpen ? 'visible' : 'hidden'};
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
`;

// ─── Badge ────────────────────────────────────────────────────────────────────

const dotPulse = keyframes`
    0%, 100% { opacity: 0.3; transform: scale(0.8); }
    50% { opacity: 1; transform: scale(1); }
`;

export const BadgeWrapper = styled.div`
    position: absolute;
    top: -6px;
    right: -6px;
    z-index: 10;
`;

export const ThinkingBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    background: ${p => p.theme.aiChat.card.background};
    border: 1.5px solid ${p => p.theme.aiChat.pill.expandedBorder};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

export const ThinkingDot = styled.span<{ $delay: number }>`
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${p => p.theme.aiChat.pill.leadingIcon};
    animation: ${dotPulse} 1.2s ease-in-out infinite;
    animation-delay: ${p => p.$delay}ms;
`;

export const UnreadBadge = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${red400};
    border: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: ${neutralWhite};
    }
`;
